<template>
    <div class="LifeDetailed text-center">
        <div class="LifeDetailed__content container-inner">
            <slider-question
                v-bind:key="1"
                v-if="this.$store.state.step == 1"
                v-bind="{
                    title: 'Outstanding debt',
                    description:
                        'What is the total amount of your outstanding debt? <br>(e.g. mortgages, personal loans, credit card etc.)',
                    min: 0,
                    type: 'money',
                    format: 'thousands',
                    max: 200000,
                    tick: 50000,
                    step: 10000,
                    value: this.$store.state.debts,
                    customVal: this.$store.state.customDebts,
                    name: 'debts',
                    customName: 'customDebts',
                    previous: 1,
                    next: 2
                }"
            ></slider-question>

            <slider-question
                v-bind:key="2"
                v-if="this.$store.state.step == 2"
                v-bind="{
                    title: 'Your Expenses',
                    description:
                        'What is your estimated weekly household spending beside debt repayments? <br>(e.g. groceries, utilities, school fees, etc.)',
                    min: 0,
                    type: 'money',
                    max: 5000,
                    tick: 1000,
                    step: 250,
                    value: this.$store.state.expenses,
                    customVal: this.$store.state.customExpenses,
                    name: 'expenses',
                    customName: 'customExpenses',
                    previous: 1,
                    next: 3
                }"
            ></slider-question>

            <slider-question
                v-bind:key="3"
                v-if="this.$store.state.step == 3"
                v-bind="{
                    title: 'Other Income',
                    description:
                        'What is your annual after-tax income from sources other than your salary and wages? (e.g.partner\'s income, investments, government support etc.)',
                    min: 0,
                    type: 'money',
                    format: 'thousands',
                    max: 20000,
                    tick: 5000,
                    step: 1000,
                    value: this.$store.state.incomeOther,
                    customVal: this.$store.state.customIncomeOther,
                    name: 'incomeOther',
                    customName: 'customIncomeOther',
                    previous: 2,
                    next: 4
                }"
            ></slider-question>

            <button-question
                v-bind:key="4"
                v-if="this.$store.state.step == 4"
                v-bind="{
                    title: 'Children',
                    description:
                        'Your children should be given the best start in life with a quality education, even if you’re no longer around. Do you have any school-aged children (under 18)?',
                    previous: 3,
                    responses: {
                        1: {
                            title: 'No',
                            id: false,
                            icon: person,
                            next: 'results'
                        },
                        2: {
                            title: 'Yes',
                            id: true,
                            icon: personWithChild,
                            next: 5
                        }
                    },
                    value: this.$store.state.children,
                    name: 'children'
                }"
            ></button-question>

            <button-question
                v-bind:key="5"
                v-if="this.$store.state.step == 5"
                v-bind="{
                    title: 'School',
                    description: 'Do your children go to private or government school?',
                    previous: 4,
                    responses: {
                        1: {
                            title: 'Private',
                            id: 'private',
                            icon: privateSchool,
                            next: 6
                        },
                        2: {
                            title: 'Government',
                            id: 'government',
                            icon: govtSchool,
                            next: 6
                        }
                    },
                    value: this.$store.state.school,
                    name: 'school'
                }"
            ></button-question>

            <slider-question
                v-bind:key="6"
                v-if="this.$store.state.step == 6"
                v-bind="{
                    title: 'Children',
                    description: 'How many children do you have?',
                    min: 1,
                    type: 'number',
                    max: 5,
                    tick: 1,
                    step: 1,
                    value: this.$store.state.childrenNumber,
                    customVal: this.$store.state.customChildrenNumber,
                    name: 'childrenNumber',
                    customName: 'customChildrenNumber',
                    previous: 5,
                    next: 7
                }"
            ></slider-question>

            <multi-slider-question
                v-bind:key="7"
                v-if="this.$store.state.step == 7"
                v-bind="{
                    title: 'Children',
                    description:
                        'How old ' + (this.$store.state.childrenNumber > 1 ? 'are your children?' : 'is your child?'),
                    min: 1,
                    type: 'number',
                    max: 17,
                    tick: 3,
                    start: 9,
                    step: 1,
                    length: this.$store.state.childrenNumber
                        ? this.$store.state.childrenNumber
                        : this.$store.state.customChildrenNumber,
                    value: this.$store.state.childrenAge,
                    measure: 'Child',
                    name: 'childrenAge',
                    previous: 6,
                    next: 'results'
                }"
            ></multi-slider-question>
        </div>
        <slot />
    </div>
</template>

<script>
import SliderQuestion from '../components/questions/SliderQuestion.vue';
import ButtonQuestion from '../components/questions/ButtonQuestion.vue';
import MultiSliderQuestion from '../components/questions/MultiSliderQuestion.vue';
import govtSchool from '@/assets/icons/govt-school.svg';
import privateSchool from '@/assets/icons/private-school.svg';
import person from '@/assets/icons/individual.svg';
import personWithChild from '@/assets/icons/family.svg';
import yes from '@/assets/icons/yes.svg';
import no from '@/assets/icons/no.svg';

export default {
    name: 'DetailedLife',
    components: {
        SliderQuestion,
        ButtonQuestion,
        MultiSliderQuestion
    },
    created: function() {
        this.$store.commit('update', { name: 'calculator', value: 'detailed' });
        this.$store.commit('update', { name: 'product', value: 'life' });
    },
    props: {
        meta: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            govtSchool,
            privateSchool,
            person,
            personWithChild,
            yes,
            no
        };
    },
    metaInfo() {
        return this.meta;
    }
};
</script>
